var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h1', {
    staticClass: "text-primary"
  }, [_vm._v("折價券兌換")]), _c('h2', [_vm._v("優惠序號兌換")]), _c('div', {
    staticClass: "p-4"
  }, [_vm.redeemCode ? _c('div', {
    staticClass: "h2 border no p-3"
  }, [_vm._v(_vm._s(_vm.redeemCode.code))]) : _vm._e(), _c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v("*折扣碼將於 " + _vm._s(_vm.timerDisplay) + " 後失效")]), _c('a', {
    staticClass: "button my-3",
    attrs: {
      "href": _vm.link
    }
  }, [_vm._m(0)])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "h4 mb-0 font-weight-bold text-primary"
  }, [_vm._v("立即"), _c('br'), _vm._v("前往購買")]);
}]

export { render, staticRenderFns }